import { getSurveyData } from "../DynamicSurveyActions";

export const FETCH_SURVEY_ESTABLISHMENTS_START = "FETCH_SURVEY_ESTABLISHMENTS_START"
export const FETCHED_SURVEY_ESTABLISHMENTS_SUCCESS = "FETCHED_SURVEY_ESTABLISHMENTS_SUCCESS"
export const SELECT_SURVEY_ESTABLISHMENT = "SELECT_SURVEY_ESTABLISHMENT"
export const ANYWHERE_PARAM_ESTABLISHMENT = "ANYWHERE_PARAM_ESTABLISHMENT"
export const START_WITH_PARAM_ESTABLISHMENTS = "START_WITH_PARAM_ESTABLISHMENTS"
export const SIGNED_SEARCH = "SIGNED_SEARCH";
export const REJECTED_SEARCH = "REJECTED_SEARCH";
export const APPROVED_SEARCH = "APPROVED_SEARCH";

export const SignedStates = {
  YES: "yes",
  NO: "no",
  ALL: "all"
};

export const ApprovedStates = {
  YES: "yes",
  NO: "no",
  ALL: "all"
};

export const RejectedStates = {
  YES: "yes",
  NO: "no",
  ALL: "all"
};

export function fetchEstablishments(first) {

  return (dispatch, getState) => {

    dispatch(fetchSurveyEstablishmentsStart(first, getState().internationalizationReducer.activeLangCode))

    let inputBody = {};
    inputBody.paging = {
      currentPage: getState().establishmentsReducer.currentPage,
      itemsPerPage: 20
    }

    inputBody.search = {
      anywhere: getState().establishmentsReducer.searchAnywhereParam,
      startingWith: getState().establishmentsReducer.startWithParam,
      lang: "en",
      year: getState().dynamicSurveyReducer.selectedYear,
      signed: getState().establishmentsReducer.signedSearch,
      rejected: getState().establishmentsReducer.rejectedSearch,      
      approved: getState().establishmentsReducer.approvedSearch
    }

    return fetch('/ndapmoci/survey/establishments', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: "Bearer " + getState().loginReducer.loginData.token
      },
      body: JSON.stringify(inputBody),
    }).then((response) => {
      if (!response.ok)
        throw Error(response.statusText)
      return response
    }).then((response) => response.json())
      .then((responseJson) => {
        dispatch(fetchedSurveyEstablishmentsSuccess(responseJson))
      })
      .catch((error) => {
        console.error(error);
      })
  }
}

export function fetchSurveyEstablishmentsStart(first, activeLangCode) {
  return { type: FETCH_SURVEY_ESTABLISHMENTS_START, first, activeLangCode };
}

export function fetchedSurveyEstablishmentsSuccess(surveyEstablishments) {
  return { type: FETCHED_SURVEY_ESTABLISHMENTS_SUCCESS, surveyEstablishments }
}

export function selectSurveyEstablishment(surveyEstablishmentId) {

  return (dispatch, getState) => {
    dispatch({ type: SELECT_SURVEY_ESTABLISHMENT, surveyEstablishmentId })
    let selected = getState().establishmentsReducer.surveyEstablishments.filter(x => x.selected);
    if(selected && selected[0] && selected[0].search_id) {
        dispatch(getSurveyData({year: getState().dynamicSurveyReducer.selectedYear, searchId: selected[0].search_id}));
    }
  }
}

export function searchAnywhereEstablishments(searchAnywhereParam) {
  return { type: ANYWHERE_PARAM_ESTABLISHMENT, searchAnywhereParam }
}

export function startWithEstablishments(startWithParam) {
  return { type: START_WITH_PARAM_ESTABLISHMENTS, startWithParam }
}

export const selectSignedSearch = signedSearch => ({
  type: SIGNED_SEARCH,
	signedSearch
});

export const selectRejectedSearch = rejectedSearch => ({
  type: REJECTED_SEARCH,
	rejectedSearch
});

export const selectApprovedSearch = approvedSearch => ({
  type: APPROVED_SEARCH,
	approvedSearch
});


// WEBPACK FOOTER //
// ./src/features/modules/dynamic-survey/establishments/EstablishmentsActions.js